import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import Header from "../features/Header";
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaTelegram, FaFacebook } from "react-icons/fa";
import "./contact.css";

const containerStyle = {
  width: "100%",
  height: "400px",
  borderRadius: "16px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
};

const center = {
  lat: 48.6723764, // Замініть на свої координати
  lng: 33.1152071,
};

const ContactsPage = () => {
  return (
    <>
      <Header />
      <div className="contacts-page">
        <div className="contacts-card">
          <h1 className="contacts-title">Зв'язатися з нами</h1>

          <div className="contacts-info">
            <p><FaMapMarkerAlt className="icon" /> м. Знам’янка, вул. Центральна, 12</p>
            <p><FaPhone className="icon" /> +38 (050) 123-45-67</p>
            <p><FaEnvelope className="icon" /> info@example.com</p>

            <div className="social-links">
              <a href="https://t.me/yourbot" target="_blank" rel="noreferrer">
                <FaTelegram /> Telegram
              </a>
              <a href="https://facebook.com/yourpage" target="_blank" rel="noreferrer">
                <FaFacebook /> Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="contacts-map">
          <LoadScript googleMapsApiKey="AIzaSyB3kcY9pVaksLooyXqo3RQRG2Nvb1_o46U">
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={15}
            >
              <Marker position={center} />
            </GoogleMap>
          </LoadScript>
        </div>
      </div>
    </>
  );
};

export default ContactsPage;
